const firebaseConfig = {
    apiKey: "AIzaSyC8bYu0-RVpyc3piWYcNm0KSn10I13og8Q",
    authDomain: "red-onion-cb5df.firebaseapp.com",
    projectId: "red-onion-cb5df",
    storageBucket: "red-onion-cb5df.appspot.com",
    messagingSenderId: "628979552405",
    appId: "1:628979552405:web:b24eaf7cde2c1d02870b9c"
};

export default firebaseConfig;